import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '80px 20px',
          textAlign: 'center',
          fontFamily: 'Montserrat, sans-serif',
          minHeight: '60vh',
        }}>
          <h1 style={{ color: '#2257B4' }}>Ups, algo salió mal</h1>
          <p style={{ color: '#666', marginBottom: 24 }}>
            Estamos trabajando para solucionarlo. Recargá la página o volvé al inicio.
          </p>
          <a
            href="/"
            style={{
              background: '#2257B4',
              color: '#fff',
              padding: '12px 24px',
              borderRadius: 6,
              textDecoration: 'none',
              fontWeight: 600,
            }}
          >
            Volver al inicio
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
